import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

export function BackButton({ href }: { href?: string }) {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => href ? navigate(href) : navigate(-1)}
      className="flex items-center justify-center w-9 h-9 rounded-full"
      style={{ backgroundColor: 'rgba(255,255,255,0.08)' }}
    >
      <ChevronLeft size={20} className="text-white" />
    </button>
  );
}
